import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslationsService extends MessageService {
  private localeId = environment.defaultLocale;
  private data: any;

  constructor(private translate: TranslateService) {
    super();
    this.translate.use('bg');
    this.translate.get('KENDO').subscribe((data) => {
      this.data = data;
    });
  }

  public set language(value: string) {
    this.localeId = value;
    this.notify(false);
  }
  public get language(): string {
    return this.localeId;
  }

  private get messages() {
    return this.data;
  }

  public override get(key: string) {
    // console.log('translate', key);
    if (this.messages) {
      return this.messages[key];
    }
  }
}

const sortMap = () => {
  const map = new Map();
  map.set('Status', 'OperationStatus.Name');
};
